import { render } from "./InputSocialPlatform.vue?vue&type=template&id=58c35240"
import script from "./InputSocialPlatform.vue?vue&type=script&lang=js"
export * from "./InputSocialPlatform.vue?vue&type=script&lang=js"
script.render = render

export default script